import { createSelector } from "reselect"
import { get } from "lodash"
import { computeEditingFilter } from "helpers/filters"
import { computeChipSecuritiesIds } from "helpers/filters/chips"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { classificationsMap, computeClassifications } from "helpers/classification"
import { computeSecuritiesDescriptors } from "helpers/securities"
import { getTagCategories, getAttributeCategories, getAssetType } from "modules/portfolio-root/selectors"
import { getViewType } from "modules/portfolio-root/selectors/portfolios"
import { getFetchStartDate } from "./dates"

export const getPortfolioFilters = state => get(state, "global.data.portfolioFilters.data")
const getEditing = state => get(state, "modules.assetAnalytics.editingFilter")
const getRawClassifications = (state) => get(state, "global.data.classifications.data.classifications")
export const getFilter = state => get(state, "modules.assetAnalytics.filter")
export const getClassificationsValues = (state) => get(state, "global.data.classificationsValues.data")
const getPortfolioSecuritiesDescriptors = (state) => get(state, "global.data.portfolioSecuritiesDescriptors.data")
export const getNormalization = (state) => get(state, "modules.assetAnalytics.normalization")

export const getSecuritiesDescriptors = createSelector(
  [getPortfolioSecuritiesDescriptors],
  computeSecuritiesDescriptors,
)

export const getChipSecuritiesIds = createSelector(
  [getFilter],
  computeChipSecuritiesIds,
)

export const getClassifications = createSelector(
  [getRawClassifications, getFetchStartDate],
  computeClassifications,
)

export const getFilterOns = createSelector(
  [getViewType, getPortfolioFilters, getFilter, getEditing, getTagCategories, getClassifications, getClassificationsValues, getAttributeCategories, getAssetType, getNormalization],
  computeFilterOns,
)

export const getEditingFilter = createSelector(
  [getFilter, getEditing, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getFetchStartDate],
  classificationsMap,
)
